"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuGroup = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _FocusManagerWithArrowKeyNavigation = require("../FocusManagerWithArrowKeyNavigation");
var _Icon = require("../Icon");
var _StatusIndicator = require("../StatusIndicator");
var _Text = require("../Text");
var _SubMenuModule = _interopRequireDefault(require("./SubMenu.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Type definitions for submenu child props

const SubMenuGroup = _ref => {
  let {
    children,
    groupTitle,
    groupIcon,
    groupIconSize,
    groupIconType,
    collapsible = false,
    disabled = false,
    onChange,
    selectedMenuKey,
    status,
    classNames
  } = _ref;
  const isSubMenuGroupChildSelected = React.Children.toArray(children).some(child => {
    if (/*#__PURE__*/React.isValidElement(child)) {
      return child.props.menuKey === selectedMenuKey;
    }
    return false;
  });
  const [collapsed, setCollapsed] = React.useState(!isSubMenuGroupChildSelected);
  const collapseHandler = () => {
    if (collapsible) {
      setCollapsed(!collapsed);
    }
  };
  const onMenuItemChangeHandler = value => {
    onChange?.(value);
  };
  const onKeyDownHandlerHeader = e => {
    if (e.key === 'Enter') {
      collapseHandler();
    }
  };
  const childrenWithProps = React.Children.map(children, child => {
    if (/*#__PURE__*/React.isValidElement(child)) {
      const {
        disabled: disabledChild
      } = child.props;
      return /*#__PURE__*/React.cloneElement(child, {
        selectedMenuKey,
        onChange: onMenuItemChangeHandler,
        disabled: disabledChild || disabled
      });
    }
    return child;
  });
  React.useEffect(() => {
    setCollapsed(!isSubMenuGroupChildSelected);
  }, [selectedMenuKey]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classify.default)(_SubMenuModule.default.subMenuGroupWrapper, classNames?.wrapper),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classify.default)(_SubMenuModule.default.subMenuGroupHeader, {
        [_SubMenuModule.default.collapsible]: collapsible
      }, {
        [_SubMenuModule.default.highlightedMenu]: isSubMenuGroupChildSelected
      }, {
        [_SubMenuModule.default.collapsed]: !collapsed
      }, classNames?.groupHeader),
      onClick: collapseHandler,
      onKeyDown: onKeyDownHandlerHeader,
      tabIndex: disabled ? -1 : 0,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _SubMenuModule.default.groupTitleWrapper,
        children: [(!!groupIcon || !!status) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _SubMenuModule.default.groupIconWrapper,
          children: [!!groupIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            color: _Text.TEXT_COLORS.inverseSecondary,
            name: groupIcon,
            type: groupIconType,
            size: groupIconSize,
            className: _SubMenuModule.default.groupIcon
          }), !!status && collapsed && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _classify.default)(_SubMenuModule.default.statusIndicatorWrapper),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StatusIndicator.StatusIndicator, {
              status: status,
              classNames: {
                wrapper: _SubMenuModule.default.statusIndicatorWrapper
              }
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.ButtonTextMedium, {
          color: _Text.TEXT_COLORS.inverseSecondary,
          className: _SubMenuModule.default.groupTitle,
          children: groupTitle
        })]
      }), collapsible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: _Text.TEXT_COLORS.inverseSecondary,
        name: collapsed ? 'chevron-down' : 'chevron-up',
        size: "small"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_SubMenuModule.default.subMenuGroup, {
        [_SubMenuModule.default.collapsed]: collapsible && collapsed
      }, classNames?.menuGroup),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusManagerWithArrowKeyNavigation.FocusManagerWithArrowKeyNavigation, {
        classNames: {
          wrapper: (0, _classify.default)(_SubMenuModule.default.subMenuFocusWrapper)
        },
        focusItemOnOpen: true,
        loop: true,
        children: childrenWithProps
      })
    })]
  });
};
exports.SubMenuGroup = SubMenuGroup;